import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Router } from '@angular/router';
import { startWith, map, Observable } from 'rxjs';
import { MyListingsService } from '../../services/my-listings.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { HeaderComponent } from '../header/header.component';
import { ToastService, ToastType } from '../../services/toast.service';

@Component({
  selector: 'app-exterior',
  templateUrl: './exterior.component.html',
  styleUrls: ['./exterior.component.css']
})
export class ExteriorComponent {
  @ViewChild(HeaderComponent) header: HeaderComponent;

  historyState: any;
  myListingId: string;
  isLoader = false;
  exteriorData: {};

  poolCtrl = new FormControl('');
  porchCtrl = new FormControl('');
  fenceCtrl = new FormControl('');
  exteriorCtrl = new FormControl('');

  filteredPoolFeatures: Observable<string[]>;
  filteredPorchFeatures: Observable<string[]>;
  filteredFence: Observable<string[]>;
  filteredExteriorFeatures: Observable<string[]>;

  separatorKeysCodes: number[] = [ENTER, COMMA];

  ArchitecturalStyle: String = '';
  PoolFeatures: any[] = [];
  ExteriorFeatures: any[] = [];
  Fencing: any[] = [];
  PatioAndPorchFeatures: any[] = [];

  // allpoolFeatures: string[] = ['Association', 'Cabana', 'Community', 'Fenced', 'None', 'Other', 'Private', 'Tile', 'Vinyl', 'Waterfall'];
  allpoolFeatures: string[] = ['Above Ground', 'Association', 'Black Bottom', 'Cabana', 'Community', 'Diving Board', 'Electric Heat', 'ENERGY STAR Qualified pool pump', 'Fenced', 'Fiberglass', 'Filtered', 'Gas Heat', 'Gunite', 'Heated', 'Indoor', 'Infinity', 'In Ground', 'Lap', 'Liner', 'None', 'Other', 'Outdoor Pool', 'Pool/Spa Combo', 'Pool Cover', 'Pool Sweep', 'Private', 'Salt Water', 'Screen Enclosure', 'Solar Cover', 'Solar Heat', 'Sport', 'Tile', 'Vinyl', 'Waterfall'];
  // allporchFeatures: string[] = ['Awning(s)', 'Covered', 'Deck', 'Enclosed', 'None', 'Other', 'Patio'];
  allporchFeatures: string[] = ['Awning(s)', 'Covered', 'Deck', 'Enclosed', 'Front Porch', 'Glass Enclosed', 'None', 'Other', 'Patio', 'Porch', 'Rear Porch', 'Screened', 'Side Porch', 'Terrace', 'Wrap Around'];
  // allFencing: string[] = ['Block', 'Brick', 'Electric', 'Full', 'None', 'Other', 'Partial', 'Security', 'Stone'];
  allFencing: string[] = ['Back Yard', 'Barbed Wire', 'Block', 'Brick', 'Chain Link', 'Cross Fenced', 'Electric', 'Fenced', 'Front Yard', 'Full', 'Gate', 'Invisible', 'Masonry', 'None', 'Other', 'Partial', 'Partial Cross', 'Perimeter', 'Pipe', 'Privacy', 'Security', 'Slump Stone', 'Split Rail', 'Stone', 'Vinyl', 'Wire', 'Wood', 'Wrought Iron'];
  // allExteriorFeatures: string[] = ['Barbecue', 'Basketball Court', 'Boat Slip', 'None', 'Other', 'Playground', 'Storage', 'Tennis Court(s)'];
  allExteriorFeatures: string[] = ['Awning(s)', 'Balcony', 'Barbecue', 'Basketball Court', 'Boat Slip', 'Built-in Barbecue', 'Courtyard', 'Covered Courtyard', 'Dock', 'Dog Run', 'Electric Grill', 'Fire Pit', 'Garden', 'Gas Grill', 'Gray Water System', 'Kennel', 'Lighting', 'Misting System', 'None', 'Other', 'Outdoor Grill', 'Outdoor Kitchen', 'Outdoor Shower', 'Permeable Paving', 'Playground', 'Private Entrance', 'Private Yard', 'Rain Barrel/Cistern(s)', 'Rain Gutters', 'RV Hookup', 'Storage', 'Tennis Court(s)', 'Uncovered Courtyard'];

  @ViewChild('poolFeatureInput') poolFeatureInput: ElementRef<HTMLInputElement>;
  @ViewChild('porchFeatureInput') porchFeatureInput: ElementRef<HTMLInputElement>;
  @ViewChild('fenceInput') fenceInput: ElementRef<HTMLInputElement>;
  @ViewChild('exteriorFeatureInput') exteriorFeatureInput: ElementRef<HTMLInputElement>;

  constructor(
    private router: Router,
    public localStorageService: LocalStorageService,
    public myListingsService: MyListingsService,
    public toastService: ToastService
  ) {
    this.filteredPoolFeatures = this.poolCtrl.valueChanges.pipe(
      startWith(null),
      map((PoolFeatures: string | null) =>
        PoolFeatures ? this._filterPoolFeatures(PoolFeatures) : this.allpoolFeatures.slice()
      )
    );

    this.filteredPorchFeatures = this.porchCtrl.valueChanges.pipe(
      startWith(null),
      map((PatioAndPorchFeatures: string | null) =>
        PatioAndPorchFeatures ? this._filteredPorchFeatures(PatioAndPorchFeatures) : this.allporchFeatures.slice()
      )
    );
    this.filteredFence = this.fenceCtrl.valueChanges.pipe(
      startWith(null),
      map((Fencing: string | null) =>
        Fencing ? this._filteredFence(Fencing) : this.allFencing.slice()
      )
    );
    this.filteredExteriorFeatures = this.exteriorCtrl.valueChanges.pipe(
      startWith(null),
      map((ExteriorFeatures: string | null) =>
        ExteriorFeatures ? this._filteredExteriorFeatures(ExteriorFeatures) : this.allExteriorFeatures.slice()
      )
    );

  }

  addPoolFeatures(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.PoolFeatures.push(value);
    }
    event.chipInput!.clear();
    this.poolCtrl.setValue(null);
  }

  removePoolFeatures(PoolFeatures: string): void {
    const index = this.PoolFeatures.indexOf(PoolFeatures);
    if (index >= 0) {
      this.PoolFeatures.splice(index, 1);
    }
  }

  selectedPoolFeatures(event: MatAutocompleteSelectedEvent): void {
    this.PoolFeatures.push(event.option.viewValue);
    this.PoolFeatures = this.removeDuplicates(this.PoolFeatures);
    this.poolFeatureInput.nativeElement.value = '';
    this.poolCtrl.setValue(null);
  }

  private _filterPoolFeatures(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allpoolFeatures.filter((PoolFeatures) =>
      PoolFeatures.toLowerCase().includes(filterValue)
    );
  }

  removeDuplicates(arr): any[] {
    return [...new Set(arr)];
  }

  addPorchFeatures(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.PatioAndPorchFeatures.push(value);
    }
    event.chipInput!.clear();
    this.porchCtrl.setValue(null);
  }

  removePorchFeatures(PatioAndPorchFeatures: string): void {
    const index = this.PatioAndPorchFeatures.indexOf(PatioAndPorchFeatures);
    if (index >= 0) {
      this.PatioAndPorchFeatures.splice(index, 1);
    }
  }

  selectedPorchFeatures(event: MatAutocompleteSelectedEvent): void {
    this.PatioAndPorchFeatures.push(event.option.viewValue);
    this.PatioAndPorchFeatures = this.removeDuplicates(this.PatioAndPorchFeatures);
    this.porchFeatureInput.nativeElement.value = '';
    this.porchCtrl.setValue(null);
  }

  private _filteredPorchFeatures(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allporchFeatures.filter((PatioAndPorchFeatures) =>
      PatioAndPorchFeatures.toLowerCase().includes(filterValue)
    );
  }

  addFence(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.Fencing.push(value);
    }
    event.chipInput!.clear();
    this.fenceCtrl.setValue(null);
  }

  removeFence(Fencing: string): void {
    const index = this.Fencing.indexOf(Fencing);
    if (index >= 0) {
      this.Fencing.splice(index, 1);
    }
  }

  selectedFence(event: MatAutocompleteSelectedEvent): void {
    this.Fencing.push(event.option.viewValue);
    this.Fencing = this.removeDuplicates(this.Fencing);
    this.fenceInput.nativeElement.value = '';
    this.fenceCtrl.setValue(null);
  }

  private _filteredFence(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allFencing.filter((Fencing) =>
      Fencing.toLowerCase().includes(filterValue)
    );
  }

  addExteriorFeatures(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.ExteriorFeatures.push(value);
    }
    event.chipInput!.clear();
    this.exteriorCtrl.setValue(null);
  }

  removeExteriorFeatures(ExteriorFeatures: string): void {
    const index = this.ExteriorFeatures.indexOf(ExteriorFeatures);
    if (index >= 0) {
      this.ExteriorFeatures.splice(index, 1);
    }
  }

  selectedExteriorFeatures(event: MatAutocompleteSelectedEvent): void {
    this.ExteriorFeatures.push(event.option.viewValue);
    this.ExteriorFeatures = this.removeDuplicates(this.ExteriorFeatures);
    this.exteriorFeatureInput.nativeElement.value = '';
    this.exteriorCtrl.setValue(null);
  }

  private _filteredExteriorFeatures(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allExteriorFeatures.filter((ExteriorFeatures) =>
      ExteriorFeatures.toLowerCase().includes(filterValue)
    );
  }

  ngOnInit(): void {
    this.historyState = history.state;
    if (!this.historyState.address) {
      this.router.navigateByUrl('/my-listing');
      return;
    }
    this.myListingId = this.historyState.myListingId ? this.historyState.myListingId : this.localStorageService.get('myListingId') ? this.localStorageService.get('myListingId') : null;
    if (this.historyState && this.historyState.exteriorData) {
      this.ArchitecturalStyle = this.historyState.exteriorData.ArchitecturalStyle;
      this.PoolFeatures = this.historyState.exteriorData.PoolFeatures;
      this.PatioAndPorchFeatures = this.historyState.exteriorData.PatioAndPorchFeatures;
      this.Fencing = this.historyState.exteriorData.Fencing;
      this.ExteriorFeatures = this.historyState.exteriorData.ExteriorFeatures;
    } else {
      // this.ArchitecturalStyle = this.historyState.listingDetails ? this.historyState.listingDetails.ArchitecturalStyle : null;
      if (this.historyState.listingDetails && this.historyState.listingDetails.ArchitecturalStyle) {
        if (typeof (this.historyState.listingDetails.ArchitecturalStyle) == 'string') {
          this.ArchitecturalStyle = this.historyState.listingDetails.ArchitecturalStyle;
        }

      } else if (this.historyState.propertyDetails && this.historyState.propertyDetails.ArchitecturalStyle) {

        if (typeof (this.historyState.propertyDetails.ArchitecturalStyle) == 'string') {
          this.ArchitecturalStyle = this.historyState.listingDetails.ArchitecturalStyle;
        }


      } else {
        this.ArchitecturalStyle = "";
      }

      if (this.historyState.listingDetails && this.historyState.listingDetails.PoolFeatures) {
        this.PoolFeatures = this.historyState.listingDetails.PoolFeatures.split(',');
      } else {
        this.PoolFeatures = [];
      }
      if (this.historyState.listingDetails && this.historyState.listingDetails.PatioAndPorchFeatures) {
        this.PatioAndPorchFeatures = this.historyState.listingDetails.PatioAndPorchFeatures.split(',');
      } else {
        this.PatioAndPorchFeatures = [];
      }

      if (this.historyState.listingDetails && this.historyState.listingDetails.Fencing) {
        this.Fencing = this.historyState.listingDetails.Fencing.split(',');
      } else {
        this.Fencing = [];
      }
      if (this.historyState.listingDetails && this.historyState.listingDetails.ExteriorFeatures) {
        this.ExteriorFeatures = this.historyState.listingDetails.ExteriorFeatures.split(',');
      } else {
        this.ExteriorFeatures = [];
      }
    }
  }

  back() {
    this.router.navigateByUrl('/interior', {
      state: this.historyState
    });
  }

  saveExteriorData(submit) {

    this.isLoader = true;
    this.exteriorData = {
      ArchitecturalStyle: this.ArchitecturalStyle,
      PoolFeatures: this.PoolFeatures,
      PatioAndPorchFeatures: this.PatioAndPorchFeatures,
      Fencing: this.Fencing,
      ExteriorFeatures: this.ExteriorFeatures
    }
    this.updateMyListings(submit);
  }

  updateMyListings(submit) {
    if (submit == null || submit == 'skip') {
      if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.5) {
        this.exteriorData["stage"] = 1.5;
      }
      if (this.historyState.stageName) {
        if (this.historyState.stageName.split(',').indexOf('Exterior') <= -1) {
          this.exteriorData["stageName"] = "Exterior" + "," + this.historyState.stageName;
        }
      } else {
        this.exteriorData["stageName"] = "Exterior" + "," + "Home Details";
      }
    }

    this.exteriorData["updatedDate"] = new Date();

    this.exteriorData = this.filterInputJson(this.exteriorData);

    this.myListingsService.UpdateListing(this.myListingId, this.exteriorData).subscribe(
      {
        next: (res) => {
          if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.5) {
            this.historyState['completedIndex'] = 1.5;
          }
          this.historyState['exteriorData'] = this.exteriorData;
          this.historyState.stageName = this.exteriorData["stageName"];

          this.isLoader = false;
           if (submit == 'skip') {
            this.historyState['completedIndex'] = 1.7;
            this.router.navigateByUrl('/plans', {
              state: this.historyState
            });
          } else {
            this.router.navigateByUrl('/listing-details', {
              state: this.historyState
            });
          }

        },
        error: (err) => {
          console.log('UpdateListing err!!!!');
          this.isLoader = false;
          console.log(err);
        }
      }
    );
  }

  skip() {
    this.historyState['completedIndex'] = 1.7;
    this.router.navigateByUrl('/plans', {
      state: this.historyState
    });
  }

  filterInputJson(obj) {
    Object.keys(obj).forEach(key => {
      if (obj[key] == null) {
        delete obj[key];
      }
    });
    return obj;
  }

}
